jQuery(document).ready(function ($) {


    $('body').on('click', '.sticky_header__burger:not(.open)', function (e) {
        e.preventDefault();
        let that = $(this);
        that.addClass('opening')
        setTimeout(function () {
            that.removeClass('opening').addClass('open');
        }, 250);
        $('.sticky_header_modal').slideDown(250);
    });
    $('body').on('click', '.sticky_header__burger.open', function (e) {
        e.preventDefault();
        let that = $(this);
        that.removeClass('open').addClass('opening')
        setTimeout(function () {
            that.removeClass('opening');
        }, 250);
        $('.sticky_header_modal').slideUp(250);
    });

    $('body').on('click', '[href="#try_for_free"]', function (e){
        e.preventDefault();
        $('a[data-modal="#try_for_free_modal"]').trigger('click');
       // $('html, body').animate({scrollTop: $('#try_for_free').offset().top - 100}, 1000);
    });


    jQuery('body').on('mousemove','#request_a_demo .wpcf7-form, .request_demo .wpcf7-form', function() {
        jQuery(this).find('.wpcf7-submit').attr('disabled', true);
        if(
            jQuery(this).find('input[name="your-name"]').val() == '' ||
            jQuery(this).find('input[name="text-959"]').val() == '' ||
            jQuery(this).find('input[name="your-email"]').val() == '' ||
            jQuery(this).find('input[name="tel-353"]').val() == '' ||
            jQuery(this).find('input[name="text-131"]').val() == '' ||
            jQuery(this).find('input[name="text-313"]').val() == ''
    ) {
            jQuery(this).find('.wpcf7-submit').attr('disabled', true);
        } else {
            jQuery(this).find('.wpcf7-submit').removeAttr('disabled');
        }
    });

    jQuery('body').on('mousemove','#subscribe_to_linklogiq .wpcf7-form', function() {
        jQuery(this).find('.wpcf7-submit').attr('disabled', true);
        if(
            jQuery(this).find('input[name="your-name"]').val() == '' ||
            jQuery(this).find('input[name="text-959"]').val() == '' ||
            jQuery(this).find('input[name="your-email"]').val() == '' ||
            jQuery(this).find('input[name="tel-353"]').val() == ''
    ) {
            jQuery(this).find('.wpcf7-submit').attr('disabled', true);
        } else {
            jQuery(this).find('.wpcf7-submit').removeAttr('disabled');
        }
    });
    
});